/**
 * SolidifyableData.ts
 */
export class SolidifyableData {
    constructor(data) {
        this.data = data;
    }
    solidify() {
        if (this.dataExists(this.data)) {
            if (this.data.containsKey(SolidifyableData.RESPONSE_PARAMETER_SHORT)) {
                this.responseCode = this.data.getNumber(SolidifyableData.RESPONSE_PARAMETER_SHORT);
            }
            else if (this.data.containsKey(SolidifyableData.RESPONSE_PARAMETER)) {
                this.responseCode = this.data.getNumber(SolidifyableData.RESPONSE_PARAMETER);
            }
        }
    }
    dataExists(value) {
        return value != null;
    }
    getSafeNumber(key) {
        let value = this.data.getNumber(key);
        return isNaN(value) ? 0 : value;
    }
    isSuccess() {
        return this.responseCode == 0;
    }
    getResponseCode() {
        return this.responseCode;
    }
    getDump() {
        return this.data.getDump();
    }
}
SolidifyableData.RESPONSE_PARAMETER_SHORT = "rsp";
SolidifyableData.RESPONSE_PARAMETER = "response";
SolidifyableData.WRAPPER_OBJECT = "wrapperObject";
//# sourceMappingURL=SolidifyableData.js.map